export const round = (number: number, decimals = 0) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: decimals,
        minimumFractionDigits: decimals,
        useGrouping: false,
    });

    const rounded = formatter.format(number);

    return Number(rounded);
};
